export const getters = {
    pageEnv(state) {
        return state.environment
    },
    userCellphone(state) {
        return state.cellphone
    },
    activityResp(state) {
        return state.activityResp
    },
    userFillinfo(state) {
        return state.fillinfo
    },
    getLesson(state) {
        return state.lesson
    },
    getProfile(state){
        return state.profile
    }
}



// WEBPACK FOOTER //
// ./src/store/getters.js